import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {getUserByToken, login} from '../core/_requests'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'

import authService from "../../../../data/oidc/AuthService";
import {ICoreState} from "../../../../data/redux/coreReducer";
import {useSelector} from "react-redux";

export function Login() {
  //const [loading, setLoading] = useState(false)
  //const {saveAuth, setCurrentUser} = useAuth()

  const [loading,setLoading]=useState(false)
  const authState: ICoreState = useSelector((state: any) => state.core)
  const {isLoading, user} = authState

  

  const authenticateUser = (event:React.ChangeEvent<any>) => {
    // Setitem to monitor opening of slideout
    //localStorage.setItem('isFormOpen', 'true')
    
    event.preventDefault();
    setLoading(true)

    authService.login()
  }

  // const formik = useFormik({
  //   initialValues,
  //   validationSchema: loginSchema,
  //   onSubmit: async (values, {setStatus, setSubmitting}) => {
  //     setLoading(true)
  //     try {
  //       const {data: auth} = await login(values.email, values.password)
  //       saveAuth(auth)
  //       const {data: user} = await getUserByToken(auth.api_token)
  //       setCurrentUser(user)
  //     } catch (error) {
  //       console.error(error)
  //       saveAuth(undefined)
  //       setStatus('The login detail is incorrect')
  //       setSubmitting(false)
  //       setLoading(false)
  //     }
  //   },
  // })

  return (
    <form
      className='form w-100'
      onSubmit={authenticateUser}
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <div className="mb-4 d-flex align-items-center justify-content-center" style={{width:70,height:70,margin:'auto',borderRadius:50,backgroundColor:'#a1dee9'}}>
          <KTSVG path='/assets/media/icons/duotune/general/gen032.svg' className='svg-icon-3x svg-icon-dark pb-2' />
        </div>
        <h1 className='text-dark mb-3'>Merchant Console</h1>
        <div className='text-gray-400 fw-bold fs-4'>
          Provides a 360º view of a customer account
        </div>
      </div>
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-dark w-75 mb-5'
        >
          {!loading && <span className='indicator-label'>Continue</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </form>
  )
}